import React from 'react';
import Icon from '../../../../shared/design-system/components/atoms/icon';
import { OverlayTooltip } from '../../../../shared/design-system/components/overlay';
import { FailedEmailAttachment } from '../../../../shared/components/email-preview-modal/type';
import { getFailedAttachmentByType, getTotalAttachmentLabel } from '../helpers';

export const getAttachmentIcon = (
  attachments: any[],
  failedAttachments: FailedEmailAttachment[],
) => {
  if (
    (!attachments || attachments?.length === 0) &&
    (!failedAttachments || failedAttachments?.length === 0)
  ) {
    return <></>;
  }

  if (
    (attachments && attachments.length > 0) ||
    (failedAttachments && failedAttachments.length > 0)
  ) {
    const successAttachmentReasons = getTotalAttachmentLabel([
      ...attachments,
      ...failedAttachments,
    ]);
    const failedAttachmentsReasons = getFailedAttachmentByType(
      failedAttachments,
    );

    const finalReasons = [
      ...successAttachmentReasons,
      ...failedAttachmentsReasons,
    ];

    return (
      <OverlayTooltip
        text={
          <div>
            {finalReasons.map((reason) => (
              <li style={{ listStyle: 'none' }}>{reason}</li>
            ))}
          </div>
        }
      >
        <Icon identifier="paperclip" className="template-icon" />
      </OverlayTooltip>
    );
  }

  return <></>;
};
